let asadeReleaseTitle = document.querySelectorAll(".block_notes_title_arrow");
for (let i = 0; i < asadeReleaseTitle.length; i++) {
  let realeseList = asadeReleaseTitle[i].nextElementSibling;
  let arrowEl = asadeReleaseTitle[i].querySelector(".arrow");
  if(realeseList != null) {
    asadeReleaseTitle[i].addEventListener("click", function () {
      realeseList.classList.toggle("open_list");
      asadeReleaseTitle[i]
        .querySelector(".arrow")
        .classList.toggle("arrow_rotate");
    });
  }
}
